import { ComponentPropsWithRef } from 'react';

export interface IOption {
  value: string;
  label: string;
  additionalData?: any;
}

export interface IAutoCompleteProps extends ComponentPropsWithRef<'input'> {
  options: IOption[];
  selectedOptions: IOption[];
  containerClasses?: string;
  showLoader?: boolean;
  maxSelectedChipToShow?: number;
  error?: string;
  maxOptionsToSelect?:
    | number
    | {
        count: number;
        message: string;
      };
  disabled?: boolean;
  disableSearch?: boolean;
  onSearch?: (searchTerm: string) => void;
  onSelectionChange: (selectedOptions: IOption[]) => void;
  customOptionTemplate?: (option: IOption) => React.ReactNode;
  disableClearSearchOnOutSideClick?: boolean;
  selectedOptionWrapperClass?: string;
  selectedOptionLabelClass?: string;
  selectedOptionChipIconColor?: string;
}

export interface ISingleAutocompleteDropdown extends ComponentPropsWithRef<'input'> {
  options: IOption[];
  selectedOption: string | number;
  containerClasses?: string;
  error?: string;
  disabled?: boolean;
  sortOptions?: boolean;
  hideCloseOption?: boolean;
  showSearchIcon?: boolean;
  enableFuzzySearch?: boolean;
  notFoundCopy?: string;
  fuzzySearchAdditionalKeys?: string[];
  customOptionsContainer?: string;
  onSearch?: (searchTerm: string) => void;
  onSelectionChange: (selectedOptions: IOption | null) => void;
  customOptionTemplate?: (option: IOption) => React.ReactNode;
  customSortFunction?: (a: IOption, b: IOption) => number;
  clickstreamEvent?: { name: string; description: string };
}

export interface IOptionsList {
  options: IOption[];
  showLoader?: boolean;
  isMultiSelect?: boolean;
  onOptionClick: (option: IOption) => void;
  isOptionSelected: (option: IOption) => boolean;
  optionTemplate?: (option: IOption) => React.ReactNode;
  notFoundCopy?: string;
  customOptionsContainer?: string;
}

export interface ISelectedOptions {
  selectedOptions: IOption[];
  maxSelectedChipToShow?: number;
  disabled?: boolean;
  onOptionClick: (option: IOption) => void;
  wrapperClasses?: string;
  labelClasses?: string;
  IconColor?: string;
}

export interface ISelectedOptionChip {
  option: IOption;
  onOptionClick: (option: IOption) => void;
  wrapperClasses?: string;
  labelClasses?: string;
  IconColor?: string;
}

export enum InputStates {
  DEFAULT = 'DEFAULT',
  ACTIVE = 'ACTIVE',
  ERROR = 'ERROR'
}
